// E-Ticaret › Hizmetler (Hizmetlerimiz) Sayfası Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.services';

export const ecommerceServicesGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Hizmetler sayfası nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizin Hizmetlerimiz sayfasını bölüm bölüm burada hazırlarsınız: üst başlık, menüdeki alt bağlantılar, kategori ve hizmet kartları, "Neden Bizi Seçmelisiniz" ve sayfa sonundaki ek bölüm. İsterseniz sayfaya yan menüde görünen ek sekmeler de eklersiniz. Değişiklikler siz yazdıkça kendiliğinden kaydedilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Hizmetler Sayfası Ayarları'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler ve +'),
    body: t(`${G}.regions.body`, 'Bölümler'),
    footer: t(`${G}.regions.footer`, 'Varsayılan ayarlara sıfırla'),
  },
  navItems: [
    t(`${G}.nav.general`, 'Hizmet Ayarları'),
    t(`${G}.nav.custom`, 'Özel sekmeler'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Hero ve alt menü'),
      text: t(`${G}.s1.text`, '"Hero Bölümü" sayfanın en üstündeki büyük başlık / görsel alanıdır. "Alt Menü Ekleme" bölümünde "Alt Menü Ekle" ile eklediğiniz öğeler, Menü 3\'te Hizmetlerimiz altında açılır (flyout) menü olarak görünür. Her öğeye "Menü Başlığı" ve "Link" yazın; sayfa seçmek için arama simgesini (Sayfalardan seç) kullanın, Sayfalar ekranındaki slug / adres eklenir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Menü başlığı boş olan öğeler sitede görünmez. "Aktif" anahtarı öğeyi gösterir / gizler; oklarla sırayı değiştirir, çöp kutusuyla silersiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kategori bölümü'),
      text: t(`${G}.s2.text`, '"Kategori Bölümü"nde başlık, açıklama ve arka plan rengini yazın; "İstatistikler" kısmında Mutlu Müşteri, Ürün/Hizmet Yelpazesi, Müşteri Desteği ve Memnuniyet Oranı değerlerini girin. Her bölümün başındaki görünürlük anahtarıyla bölümü sayfada gösterir veya gizlersiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Hizmet ekleyin'),
      text: t(`${G}.s3.text`, '"Hizmetlerimiz Bölümü"nde bölüm başlığı, açıklaması ve arka plan rengini yazın; "Yeni Hizmet Ekle" ile her hizmet için bir kart ekleyin. Kartta başlık, açıklama, renk ve ikon seçin; kartın Aktif / Gizli durumunu değiştirerek sayfada gösterip gizleyin.'),
      tips: [
        t(`${G}.s3.tip1`, '"Detaya git linkini göster" açıksa kartta bir link çıkar: "Detay linki"ne adres (ör. /contact veya https://...) ve "Link metni" yazın. Detay linki boşsa link sitede görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Neden Biz ve ek bölüm'),
      text: t(`${G}.s4.text`, '"Neden Bizi Seçmelisiniz Bölümü"nde başlık, açıklama, arka plan rengi ve en çok 6 özellik (başlık, açıklama, isteğe bağlı görsel) girin. "Ek Bölüm (CTA)" sayfanın en altında görünen çağrı / iş birliği alanıdır.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s5.title`, '5. Ek sekmeler'),
      text: t(`${G}.s5.text`, 'Sekmelerin sağındaki + (Yeni Sekme Ekle) sayfaya yan menüde görünen yeni bir sekme ekler. Sekmede "Sekme Adı" (yan menüde buton olarak görünür), sayfa başlığı, ana içerik (HTML editör) ve "Yeni Bölüm Ekle" ile başlık-içerik bölümleri girilir; sekmeyi Aktif ya da Gizli yapabilirsiniz. Sekmeleri sürükleyerek sıralayın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sekme silme işlemi onay sorar ve geri alınamaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Varsayılana dönmek'),
      text: t(`${G}.s6.text`, 'Başlığın sağındaki "Varsayılan ayarlara sıfırla" düğmesi ana hizmet bölümlerindeki tüm metin ve ayarları varsayılanlara döndürür ve hemen kaydeder. Onay sorulmaz; yalnız baştan başlamak istediğinizde kullanın.'),
      tips: [
        t(`${G}.s6.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
